export default (props, vars) =>
  vars?.['applicationcard5']?.['item'].descriptionComponent;
